import React, { useEffect, useRef } from 'react';
export function FlameCanvas() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let W: number, H: number;
    let particles: any[] = [];
    let animationFrameId: number;
    function resize() {
      if (!canvas) return;
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);
    // Flame colors — warm ambers + lila hints
    const colors = ['rgba(255,107,53,', 'rgba(247,147,30,', 'rgba(255,205,60,', 'rgba(196,160,232,', 'rgba(232,150,12,'];
    class Particle {
      x: number;
      y: number;
      vx: number;
      vy: number;
      life: number;
      maxLife: number;
      size: number;
      color: string;
      constructor(x: number) {
        this.x = x;
        this.y = H + 20;
        this.vx = (Math.random() - 0.5) * 0.6;
        this.vy = -(Math.random() * 2 + 1.2);
        this.life = 0;
        this.maxLife = Math.random() * 120 + 80;
        this.size = Math.random() * 28 + 10;
        this.color = colors[Math.floor(Math.random() * colors.length)];
      }
    }
    function spawnFlames() {
      // Sparse flame sources near bottom
      const sources = [W * 0.15, W * 0.3, W * 0.5, W * 0.68, W * 0.82];
      sources.forEach(x => {
        if (Math.random() < 0.12) {
          particles.push(new Particle(x + (Math.random() - 0.5) * 80));
        }
      });
      // random small sparks
      if (Math.random() < 0.05) {
        particles.push(new Particle(Math.random() * W));
      }
    }
    function draw() {
      if (!ctx) return;
      ctx.clearRect(0, 0, W, H);
      spawnFlames();
      particles = particles.filter(p => p.life < p.maxLife);
      particles.forEach(p => {
        p.life++;
        p.x += p.vx + Math.sin(p.life * 0.08) * 0.4;
        p.y += p.vy;
        p.vy *= 0.995;
        const prog = p.life / p.maxLife;
        const alpha = (1 - prog) * 0.55;
        const size = p.size * (1 - prog * 0.7);
        const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, size);
        grad.addColorStop(0, p.color + alpha + ')');
        grad.addColorStop(0.5, p.color + alpha * 0.4 + ')');
        grad.addColorStop(1, p.color + '0)');
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(p.x, p.y, size, 0, Math.PI * 2);
        ctx.fill();
      });
      animationFrameId = requestAnimationFrame(draw);
    }
    draw();
    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <canvas ref={canvasRef} id="flame-canvas" className="fixed top-0 left-0 w-full h-full pointer-events-none z-0 opacity-[0.18]" data-id="element-103" />;
}